import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { loginURL, meURL } from "../api/url";
import { handleFetch } from "../../../utils/handleFetch";

class AuthStore {
  user = null;
  errors = {
    email: null,
    password: null,
  };
  isLoading = true;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoading = (v) => (this.isLoading = v);

  login = async (body) => {
    runInAction(() => (this.errors = {}));
    return await handleFetch({
      url: loginURL,
      method: "POST",
      body,
      onSuccess: (data, message) => {
        runInAction(() => {
          this.errors = {};
          setTimeout(() => {
            this.user = data;
          }, 800);
        });
        toast.success(message);
      },
      onValidationError: (errors) => runInAction(() => (this.errors = errors)),
    });
  };

  getMe = async () => {
    runInAction(() => (this.isLoading = true));
    return await handleFetch({
      url: meURL,
      method: "GET",
      onSuccess: (data) => runInAction(() => (this.user = data)),
    });
  };

  logout = () => {
    Cookies.remove("token");
    window.location.reload();
  };

  get isUserLogin() {
    return this.user ? true : false;
  }

  get role() {
    return this.user?.role;
  }

  get permissions() {
    return this.user?.permissions || [];
  }
}

export const authStore = new AuthStore();
